export function createImageObject(propertyName: string, imageUrl?: string) {
  return {
    url: imageUrl || '',
    strategies: {
      [propertyName]: imageUrl || '',
    },
    id: imageUrl || '',
  };
}
